import Add from '@mui/icons-material/Add'
import { Grid, IconButton } from '@mui/material'
import { FEATURE_BUNDLE_TYPES_ARRAY } from 'src/consumer/constants'
import { checkAndGetTargetValue } from 'src/consumer/helpers/utilFunctions'
import FeatureBundleComponent from './featureBundles/FeatureBundleComponent'

export default function BundlePackCustomPriceComponent({
  bundle,
  setSelectedPlan,
  allOneOnOnePlans,
}) {
  function setBundle(value) {
    setSelectedPlan((prev) => {
      if (typeof value === 'function') {
        return { ...(prev || {}), bundle: value(prev?.bundle || []) }
      }
      return { ...(prev || {}), bundle: value }
    })
  }

  function deleteBundle(idx) {
    setSelectedPlan((prev) => {
      const newBundles = [...prev.bundle]
      newBundles.splice(idx, 1)
      return { ...prev, bundle: newBundles }
    })
  }

  function changeBundle(eve, idx) {
    setSelectedPlan((prev) => ({
      ...(prev || {}),
      bundle: (prev?.bundle || []).map((item, index) =>
        index === idx ? { ...item, [eve?.target?.id]: checkAndGetTargetValue(eve) } : item,
      ),
    }))
  }

  function addBundle() {
    setBundle((prev) =>
      prev
        ? [...prev, { type: FEATURE_BUNDLE_TYPES_ARRAY?.[0]?.id, maxCount: 0 }]
        : [{ type: FEATURE_BUNDLE_TYPES_ARRAY?.[0]?.id, maxCount: 0 }],
    )
  }

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
      >
        <strong>Bundles</strong>
        <IconButton onClick={addBundle}>
          <Add />
        </IconButton>
      </Grid>
      {bundle?.map((bndl, idx) => (
        <Grid item xs={12} key={idx}>
          <FeatureBundleComponent
            bundle={bndl}
            deleteBundle={() => {
              deleteBundle(idx)
            }}
            changeBundle={(eve) => changeBundle(eve, idx)}
            disabled={false}
            subscriptionPlansToUse={allOneOnOnePlans}
          />
        </Grid>
      ))}
    </Grid>
  )
}
